import { render, staticRenderFns } from "./NewEventOwner.vue?vue&type=template&id=1d30e582&scoped=true&"
import script from "./NewEventOwner.vue?vue&type=script&lang=js&"
export * from "./NewEventOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d30e582",
  null
  
)

export default component.exports